import { Component, Input } from '@angular/core';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';
import * as _ from 'lodash';

@Component({
  selector: 'adminapp-summary-bnas',
  templateUrl: './summary-bnas.component.html',
  styleUrls: ['./summary-bnas.component.scss']
})
export class SummaryBNAsComponent {

  bnaList = new Array<SummaryTableEntry>();

  constructor() { }

  @Input()
  isLoading = false;

  @Input()
  set bnas(bnas: Array<any>) {
    if (!bnas || bnas.length === 0) {
      return;
    }

    const temp = [];
    _.each(bnas, function (bna) {
      temp.push(new SummaryTableEntry(bna.type, bna.count));
    });

    this.bnaList = temp;
  }
}
